import { NextImageSrc } from '@vertex-protocol/web-common';
// Equities (stocks + ETFs)
import aaplIcon from './tokenIcons/equities/aapl.png';
import amznIcon from './tokenIcons/equities/amzn.png';
import googlIcon from './tokenIcons/equities/googl.png';
import metaIcon from './tokenIcons/equities/meta.png';
import msftIcon from './tokenIcons/equities/msft.png';
import nvdaIcon from './tokenIcons/equities/nvda.png';
import tslaIcon from './tokenIcons/equities/tsla.png';
import qqqIcon from './tokenIcons/equities/qqq.svg';
import spyIcon from './tokenIcons/equities/spy.svg';
// Commodities
import wtiIcon from './tokenIcons/equities/wti.png';
import xagIcon from './tokenIcons/equities/xag.svg';
// Forex
import eurusdIcon from './tokenIcons/equities/eurusd.svg';
import gbpusdIcon from './tokenIcons/equities/gbpusd.svg';
import usdjpyIcon from './tokenIcons/equities/usdjpy.svg';

export interface TokenIconMetadata {
  asset: NextImageSrc;
}

/**
 * Icon registry for TradFi perp markets (equities, ETFs, commodities, forex).
 * Keys are uppercase ticker symbols matching the base symbol used in PerpProductMetadata.
 * Used by createEquityPerpMetadata to auto-generate metadata for new Nado TradFi markets.
 */
export const EQUITY_TOKEN_ICONS: Record<string, TokenIconMetadata> = {
  // Stocks
  AAPL: { asset: aaplIcon },
  AMZN: { asset: amznIcon },
  GOOGL: { asset: googlIcon },
  META: { asset: metaIcon },
  MSFT: { asset: msftIcon },
  NVDA: { asset: nvdaIcon },
  TSLA: { asset: tslaIcon },
  // ETFs
  QQQ: { asset: qqqIcon },
  SPY: { asset: spyIcon },
  // Commodities
  WTI: { asset: wtiIcon },
  XAG: { asset: xagIcon },
  // Forex pairs
  EURUSD: { asset: eurusdIcon },
  GBPUSD: { asset: gbpusdIcon },
  USDJPY: { asset: usdjpyIcon },
};
